export default {
  "Audio Compressor": "音声データ圧縮機",
  "HitPaw Online Audio Compressor": "HitPawオンライン音声データ圧縮機",
  "Reduce audio file size online without quality loss.": "オンライン音声データファイルのサイズを質を落とすことなく小さくします。",
  "Compress": "圧縮する",
  "Compressing": "圧縮中",
  "Compressed Successfully": "圧縮成功",
  "Compress New": "新しいものを圧縮する",
  "Compression is complete": "圧縮が完了している",
  "Compression failed": "圧縮失敗",
  "Quality": "質",
  "Format": "形式",
  "Add file": "ファイルを追加する",
  "Output Settings": "出力設定",

};
